import { render, staticRenderFns } from "./AbkSurveyStatsQuestionAnswers.vue?vue&type=template&id=c6aba9b6&scoped=true&"
import script from "./AbkSurveyStatsQuestionAnswers.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyStatsQuestionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyStatsQuestionAnswers.vue?vue&type=style&index=0&id=c6aba9b6&lang=scss&scoped=true&"
import style1 from "./AbkSurveyStatsQuestionAnswers.vue?vue&type=style&index=1&id=c6aba9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aba9b6",
  null
  
)

export default component.exports